import React from 'react'
import './Menu.css'
import { Nav } from '../../components'
import { Footer } from '../../containers'
import { images } from '../../constants'
import { motion } from 'framer-motion'
import { Helmet } from 'react-helmet'

const Menu = () => {
  const imageAnimate = {
    offscreen: { x: 100, opacity: 0 },
    onscreen: {
      x: 0,
      opacity: 1,
      rotate: [0, 10, 0],
      transition: { type: 'spring', bounce: 0.4, duration: 1 },
    },
  }
  const textAnimate = {
    offscreen: { y: 50, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: { type: 'spring', bounce: 0.4, duration: 2 },
    },
  }
  return (
    <div>
      <Helmet>
        <title>Menu - Sushi edge</title>
      </Helmet>
      <div className="container-xxl">
        <Nav />
      </div>
      <motion.div
        className="menu-container"
        initial={'offscreen'}
        whileInView={'onscreen'}
        viewport={{ once: true, amount: 0.5 }}
        transition={{ staggerChildren: 0.5 }}
      >
        <motion.img
          src={images.seaweed}
          alt="menu"
          variants={imageAnimate}
          className="img-fluid w-100"
        />
        <div className="mt-5 container-sm mb-5">
          <motion.ul
            class="nav nav-pills mb-3 justify-content-center align-items-center"
            id="pills-tab"
            role="tablist"
            variants={textAnimate}
          >
            <li
              class="nav-item"
              role="presentation"
            >
              <button
                class="nav-link nav-link-menu active"
                id="pills-sushi-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-sushi"
                type="button"
                role="tab"
                aria-controls="pills-sushi"
                aria-selected="true"
              >
                <p className="me-3">SUSHI</p>
              </button>
            </li>
            <li
              class="nav-item"
              role="presentation"
            >
              <button
                class="nav-link nav-link-menu"
                id="pills-food-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-food"
                type="button"
                role="tab"
                aria-controls="pills-food"
                aria-selected="false"
              >
                <p>MEAL</p>
              </button>
            </li>
          </motion.ul>

          <motion.div
            class="tab-content"
            id="pills-tabContent"
            variants={textAnimate}
          >
            <div
              class="tab-pane fade active show"
              id="pills-sushi"
              role="tabpanel"
              aria-labelledby="pills-sushi-tab"
              tabindex="0"
            >
              <div className="row">
                <div className="col-lg-4  col-md-6 d-flex justify-content-between menu gap-4 mb-4">
                  <h6>74 pcs Party Sushi</h6>
                  <p>$94.9</p>
                </div>
                <div className="col-lg-4  col-md-6 d-flex justify-content-between menu gap-4 mb-4">
                  <h6>57 pcs Party Sushi</h6>
                  <p>$84.9</p>
                </div>
                <div className="col-lg-4  col-md-6 d-flex justify-content-between menu gap-4 mb-4">
                  <h6>48 pcs Party Sushi</h6>
                  <p>$74.9</p>
                </div>
                <div className="col-lg-4  col-md-6  d-flex justify-content-between menu gap-4 mb-4">
                  <h6>26 pcs Party Sushi</h6>
                  <p>$41.9</p>
                </div>
                <div className="col-lg-4  col-md-6  d-flex justify-content-between menu gap-4 mb-4">
                  <h6>40 pcs Kids Party Sushi</h6>
                  <p>$41.9</p>
                </div>
                <div className="col-lg-4 col-md-6 menu mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Sushi</h6>
                    <p>$15.5</p>
                  </div>
                  <small>1 rolled sushi (10pcs)</small>
                </div>
              </div>
            </div>

            <div
              class="tab-pane fade menu"
              id="pills-food"
              role="tabpanel"
              aria-labelledby="pills-food-tab"
              tabindex="0"
            >
              <h4 className="text-center mb-5">BENTO AND KATSU</h4>
              <div className="row">
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Chicken Bento</h6>
                    <p>$23.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Teriyaki chicken, tempura, fresh salad, rolled sushi with
                      rice and miso soup
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Beef Bento</h6>
                    <p>$23.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Seasoned beef, tempura, fresh salad, rolled sushi with
                      rice and miso soup
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Pork Bento</h6>
                    <p>$23.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Pork katsu, tempura, fresh salad, rolled sushi with rice
                      and miso soup
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Fish Bento</h6>
                    <p>$23.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Teriyaki fish, tempura, fresh salad, rolled sushi with
                      rice and miso soup
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Sashimi Bento</h6>
                    <p>$23.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Sashimi, tempura, fresh salad, rolled sushi with rice and
                      miso soup
                    </small>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Chicken (or Pork) Katsu</h6>
                    <p>$18.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Deep fried chicken (or pork) cutlet with fresh salad, rice
                      and miso soup
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Chicken (or Pork) Curry Katsu</h6>
                    <p>$19.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Deep fried chicken (or pork) cutlet with curry sauce,
                      fresh salad, rice and miso soup
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Katsu Combination</h6>
                    <p>$19.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Deep fried chicken and pork cutlet with fresh salad, rice
                      and miso soup
                    </small>
                  </div>
                </div>
                <h4 className="text-center mb-5 mt-5">DONBURI AND BULGOGI</h4>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Chicken (or Beef) Don</h6>
                    <p>$17.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Seasoned chicken breast (or beef) with pan fried
                      vegetables on rice and miso soup
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Chicken (or Pork) Katsu Don</h6>
                    <p>$17.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Deep fried chicken (or pork) with pan fried vegetables and
                      egg on rice and miso soup
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Salmon Sashimi Don</h6>
                    <p>$21.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Fresh salmon, fresh vegetables with chili sauce on rice
                      and miso soup
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Salmon Teriyaki Don</h6>
                    <p>$23.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Teriyaki salmon with pan fried vegetables on rice and miso
                      soup
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Ebi Don</h6>
                    <p>$17.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      3 pcs prawn tempura with pan fried vegetables on rice and
                      miso soup
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Chicken Bulgogi</h6>
                    <p>$19.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Seasoned chicken with pan fried vegetables, rice and miso
                      soup
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Beef Bulgogi</h6>
                    <p>$19.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Seasoned beef with pan fried vegetables, rice and miso
                      soup
                    </small>
                  </div>
                </div>
                <h4 className="text-center mb-5 mt-5">UDON AND SUKIYAKI</h4>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Nabi Udon</h6>
                    <p>$17.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Udon noodle with fishcake, shrimp vegetables in soup
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Nabi Udon & Sashimi</h6>
                    <p>$24.9</p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Nabi Udon & Sushi</h6>
                    <p>$20.9</p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Nabi Udon & Nigiri Sushi</h6>
                    <p>$23.9</p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Tempura Udon</h6>
                    <p>$20.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Udon noodle with fishcake, shrimp vegetables in soup with
                      5 pcs tempura
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Chicken (or Beef) Fried Noodle</h6>
                    <p>$17.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Pan fried chicken (or beef) with udon noodles ans
                      vegetables
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Chili Chicken (or Beef) Fried Noodle</h6>
                    <p>$18.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Pan fried chicken (or beef) with udon noodles ans
                      vegetables with chili sauce
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Sukiyaki</h6>
                    <p>$18.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Special marinated tender beef simmered with vegetables and
                      vermicelli, rice
                    </small>
                  </div>
                </div>
                <h4 className="text-center mb-5 mt-5">TERIYAKI AND TEMPURA</h4>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Chicken Teriyaki</h6>
                    <p>$19.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Seared boneless chicken thigh with teriyaki sauce, rice,
                      miso soup and fresh salad
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Pork Teriyaki</h6>
                    <p>$19.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Deep fried pork with teriyaki sauce, rice, miso soup and
                      fresh salad
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Fish Teriyaki</h6>
                    <p>$19.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Pan fried fish with teriyaki sauce, rice, miso soup and
                      fresh salad
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Unagi Teriyaki</h6>
                    <p>$19.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      BBQ eel (Unagi) with teriyaki sauce, rice, miso soup and
                      fresh salad
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Salmon Teriyaki</h6>
                    <p>$23.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Pan fried salmon with teriyaki sauce, rice, miso soup and
                      fresh salad
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Combination Tempura</h6>
                    <p>$17.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      8 pcs vegetable tempura and 2 pcs prawn tempura
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Prawn Tempura</h6>
                    <p>$17.9</p>
                  </div>
                  <div className="w-75">
                    <small>(6 pcs)</small>
                  </div>
                </div>
                <h4 className="text-center mb-5 mt-5">VEGETARIAN</h4>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Vegetarian Bento</h6>
                    <p>$23.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Pan fried vegetables with tofu, tempura, fresh salad,
                      rolled sushi with rice and miso soup
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Tempura Don</h6>
                    <p>$17.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Vegetable tempura with pan fried vegetables on rice, and
                      miso soup
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Vegetarian Don</h6>
                    <p>$17.9</p>
                  </div>
                  <div className="w-75">
                    <small>Udon noodle with tofu and vegetables in soup</small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Tofu Teriyaki</h6>
                    <p>$19.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Tofu with teriyaki sauce, rice, miso soup and fresh salad
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Tofu Don</h6>
                    <p>$17.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Tofu with pan fried vegetables on rice, miso soup
                    </small>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Tofu Fried Noodle</h6>
                    <p>$17.9</p>
                  </div>
                  <div className="w-75">
                    <small>
                      Pan fried tofu and vegetables with udon noodles
                    </small>
                  </div>
                </div>
                <h4 className="text-center mb-5 mt-5">KIDS</h4>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Kids Chicken Katsu</h6>
                    <p>$12.9</p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Kids Chicken Teriyaki</h6>
                    <p>$12.9</p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Kids Sushi</h6>
                    <p>$9.2</p>
                  </div>
                </div>
                <h4 className="text-center mb-5 mt-5">SIDES</h4>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Salmon Sashimi</h6>
                    <p>$12.9</p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Edamame Bean</h6>
                    <p>$7</p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6  mb-4">
                  <div className="d-flex justify-content-between">
                    <h6>Seaweed Salad</h6>
                    <p>$7</p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </motion.div>

      <div className="container-xxl">
        <Footer />
      </div>
    </div>
  )
}

export default Menu
